import React from "react";
import { useMetabaseReport } from "Hooks/useMetabaseReport";
import Iframe from "react-iframe";
import useStyles from "./styles";
import { Typography } from "@material-ui/core";
import { MetabaseDashboardToken } from "generated/graphql";

export const EnrollmentReport = ({ title }: { title: string }) => {
  const { iframeUrl, loading } = useMetabaseReport(
    MetabaseDashboardToken.Enrollment
  );
  const classes = useStyles();

  if (!iframeUrl || loading) {
    return null;
  }

  return (
    <>
      <Typography variant="body2">
        <b>Eligible:</b> Users who are actively working with a new shift record
        sent to DailyPay through the Gross Earnings Files in the past 30
        calendar days. DailyPay's analytics exclude users created in the past 2
        weeks through the User Roster Files to allow enough time for enrollment
      </Typography>
      <Typography variant="body2">
        <b>Enrolled:</b> Eligibles users who have signed up for DP and viewed
        the PAYTM
      </Typography>
      <Typography variant="body2">
        <b>Engaged:</b> Enrolled users who have made two or more transfers
      </Typography>

      <Iframe
        className={classes.container}
        width="80%"
        height="1000"
        display="initial"
        position="absolute"
        url={iframeUrl}
        title={title}
      />
    </>
  );
};
